// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active{background-color:#c8d2e6}.side-menu{width:80%}.side-menu-nav-item{height:3rem;font-weight:bold;border-radius:0.5rem;cursor:pointer;padding-top:0.25rem;padding-left:0.25rem;text-align:left !important;vertical-align:middle}.active.side-menu-nav-item{background-color:#EFCB68;border-style:dashed;border-width:0.15rem;border-color:black;padding-left:1rem}.side-menu-nav-item:hover{background-color:#EBEBEB}\n", ""]);
// Exports
module.exports = exports;
